import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs';
import { FaqService } from 'src/app/services/faq/faq.service';
import { SpinnerComponent } from "src/app/components/layout/spinner/spinner.component";
import { LanguageService } from 'src/app/services/language/language.service';

export interface FaqPageOption {
  menu_page: number;
  title: string;
  slug?: string;
}

export interface FaqItem {
  id: number;
  lang: string;
  menu_page: number;
  question: string;
  answer: string;
  visible: number;
  sort: number;
}

@Component({
  selector: 'app-faq-modal',
  imports: [CommonModule, FormsModule, SpinnerComponent, ReactiveFormsModule],

  templateUrl: './faq-modal.component.html',
  styleUrls: ['./faq-modal.component.css'],
})
export class FaqModalComponent implements OnInit {
  @Input() lang: string = 'geo';

  // edit mode
  @Input() faqId?: number | null = null;

  // pages select list (page_type_id=35)
  @Input() pages: FaqPageOption[] = [];

  // if you open modal from a selected page, pass it here
  @Input() selectedMenuPage?: number | null = null;

  loading = false;
  saving = false;

  form!: FormGroup;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private faqService: FaqService,
    private langService: LanguageService,
    
  ) {}

  ngOnInit(): void {
    this.langService.currentLanguage$.subscribe((l) => {
      this.lang = l;
    });
    this.form = this.fb.group({
      menu_page: [this.selectedMenuPage ?? null, [Validators.required]],
      question: ['', [Validators.required, Validators.maxLength(500)]],
      answer: ['', [Validators.required]],
      visible: [1, [Validators.required]],
    });

    if (this.faqId) {
      this.loadItem(this.faqId);
    }
  }

  get f() {
    return this.form.controls;
  }

  private loadItem(id: number) {
    this.loading = true;
    this.faqService
      .show(id, this.lang)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (res: any) => {
          const item: FaqItem = res?.data ?? res;

          this.form.patchValue({
            menu_page: item.menu_page ?? this.selectedMenuPage ?? null,
            question: item.question ?? '',
            answer: item.answer ?? '',
            visible: item.visible ?? 1,
          });
        },
      });
  }

  save() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const payload = {
      ...this.form.value,
    };

    this.saving = true;

    const req$ = this.faqId
      ? this.faqService.update(this.faqId, payload, this.lang)
      : this.faqService.create(payload, this.lang);

    req$
      .pipe(finalize(() => (this.saving = false)))
      .subscribe({
        next: () => this.activeModal.close(true),
      });
  }
}